import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss']
})
export class ToastComponent implements OnChanges {
  @Input() message: string = '';
  @Input() visible: boolean = false;
  @Input() duration: number = 3000;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.visible && changes.visible.currentValue) {
    }
  }
}
